import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const SocietyRegistration = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Society Registration
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        A society is a collective of individuals united by a shared agreement to
        collaborate, manage, and pursue common goals, often focused on
        charitable endeavors such as sports, culture, education, or social
        welfare.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Definition and Purpose */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Definition and Purpose
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            As defined by the Societies Registration Act, 1860, a society is a
            type of non-governmental organization (NGO) formed by a group to
            promote non-profit causes. These may include advancing science,
            literature, arts, charitable assistance, military orphan funds,
            libraries, museums, or social development initiatives, managed by an
            elected governing body.
          </p>

          {/* Membership Structure */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Membership Structure
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            A society requires a minimum of seven members for registration,
            unlike a trust which needs only two. The application to the
            registrar must include a Memorandum of Association (MOA) detailing
            the society’s name, address, governing body members, objectives, and
            promoter names, along with rules governing membership termination
            and meetings.
          </p>

          {/* Operational Governance */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Operational Governance
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Societies are overseen by an elected body accountable to members,
            with the flexibility to delegate daily operations to full-time
            staff. While similar to trusts, societies differ in their broader
            membership base and structured governance under the 1860 Act.
          </p>

          {/* Registration Procedure */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Registration Procedure
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Registration occurs within the jurisdiction of the society’s
            registered office, following these steps:
          </p>
          <ol
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              Select a unique name, ensuring it complies with the Emblems and
              Names Act, 1950, and differs from existing societies.
            </li>
            <li>
              Prepare a Memorandum of Association (MOA), signed by founding
              members in the presence of a notary, oath commissioner, or similar
              authority, including member details and objectives.
            </li>
            <li>
              Submit required documents: PAN cards, residence proofs, MOA,
              Articles of Association (AOA), a cover letter, address proof, NOC
              from the landowner, resolution for registration, and a declaration
              by the president.
            </li>
            <li>
              File two copies of the MOA and rules with the state registrar,
              paying the specified fee, and await the incorporation certificate
              and registration number upon approval.
            </li>
          </ol>

          {/* Necessary Documentation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Necessary Documentation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Required documents include PAN cards and residence proofs (e.g.,
            Aadhaar, passport) of all members, MOA, AOA, a cover letter, proof
            of registered office address, a landowner’s NOC, a certified
            resolution, and a list of governing body members with signatures.
          </p>

          {/* Closing Remarks */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Closing Remarks
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Society registration is a strategic option for pursuing charitable
            goals with legal recognition. Proper adherence to registration steps
            and documentation ensures effective management and community
            impact.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SocietyRegistration;